import React from 'react'
import preval from 'preval.macro'
import PublicPageSF from '../../templates/PublicPageSF'

const buildDate = preval`module.exports = new Date().toJSON()`

const VersionPageUI = ({context}) =>
  <PublicPageSF context={context} className='pg_version'>
    {buildDate}
  </PublicPageSF>

export default VersionPageUI
// https://github.com/facebook/create-react-app/issues/4960
